import { Link, useNavigate } from 'react-router-dom'
import { useLang, useUser, useTrkptsWS, useSessionWS } from '../utils/hooks'

import Footer from '../components/Footer'
import { langHome } from '../assets/langHome'

import {
  freeAccount,
  subscribeAccount,
  oldSubscribeAccount,
} from '../assets/accounts'
import globaltr from '../images/global_tr.png'
import { useEffect } from 'react'
import { MdKitesurfing } from 'react-icons/md'
import { useRef } from 'react'

const Home = () => {
  const firstDiv = useRef(null)

  const { lang } = useLang()
  const { changeUser } = useUser()
  const { changeSessionWS } = useSessionWS()
  const { changeTrkptsWS } = useTrkptsWS()
  const choosenLang = lang === 'eng' ? langHome.eng : langHome.fr
  const today = new Date()

  const navigate = useNavigate()

  useEffect(() => {
    changeTrkptsWS({ brut: [], origin: '' })
  }, [])

  useEffect(() => {
    if (firstDiv.current !== null) {
      const topScroll = firstDiv.current.getBoundingClientRect().top
      window.scrollTo({ top: topScroll.current - 120, behavior: 'smooth' })
    }
  }, [])

  const callApiLoginDemo = async () => {
    const url = '/api/authMD/loginDemo'
    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        response.json().then((data) => {
          const start = data.subscribeDate ? new Date(data.subscribeDate) : null
          let end = data.subscribeDate ? new Date(data.subscribeDate) : null

          if (end) end.setMonth(end.getMonth() + Number(data.subscribeLength))
          const tempAccount = end
            ? end > today
              ? subscribeAccount
              : oldSubscribeAccount
            : freeAccount
          changeUser({
            userName: data.userName,
            userId: data.userId,
            accountType: tempAccount,
            subscribeStart: start,
            subscribeEnd: end,
          })
          changeSessionWS(null)

          localStorage.setItem('wsurf_userName', data.userName)
          localStorage.setItem('wsurf_userId', data.userId)
          localStorage.setItem('wsurf_subscribeAccount', tempAccount)
          localStorage.setItem('wsurf_subscribeStart', start)
          localStorage.setItem('wsurf_subscribeEnd', end)
          document.cookie = 'ws2=' + data.token
          navigate(`/sessions/`)
        })
      })
      .catch((error) => console.log(error))
  }

  return (
    <>
      <section
        className="hero is-white is-fullheight-with-navbar is-john"
        ref={firstDiv}
      >
        <div className="hero-body">
          <div className="columns">
            <div className="column is-one-half">
              <div className="block">
                <span className="block icon-text">
                  <span className="icon is-medium has-text-warning-light is-size-3 pb-0">
                    <MdKitesurfing />
                  </span>
                  <span className="subtitle is-2 is-size-3-mobile has-text-warning-light">
                    {choosenLang.home0}
                  </span>
                </span>
                <h1 className="subtitle is-5 is-size-5-mobile has-text-white">
                  <p>{choosenLang.home1}</p>
                </h1>
                <h1 className="subtitle is-5 has-text-white">
                  {choosenLang.home2}
                </h1>
                <h1 className="subtitle is-5 has-text-white">
                  {choosenLang.home3}
                </h1>
              </div>
            </div>
            <div className="column ">
              <div className="block">
                <h1 className="subtitle is-4  has-text-white">
                  {choosenLang.home4}
                  <Link to="/try/try" className="has-text-white is-underlined">
                    {' '}
                    {choosenLang.home5}
                  </Link>{' '}
                  {choosenLang.home6}
                </h1>
                <h1 className="subtitle is-4  has-text-white">
                  {choosenLang.home7}
                  <Link
                    to="#"
                    className="has-text-white is-underlined"
                    onClick={(e) => {
                      callApiLoginDemo()
                      e.preventDefault()
                    }}
                  >
                    {choosenLang.home8}
                  </Link>
                  {choosenLang.home9}
                </h1>
              </div>
              <div>
                <img src={globaltr} alt="global" />
              </div>
            </div>
          </div>
        </div>

        <div className="hero-foot">
          <Footer />
        </div>
      </section>
    </>
  )
}

export default Home
